import clsx from 'clsx';
import React from 'react';

const ConnectWalletMessage = ({ label = 'Please connect your wallet to continue.', bgClassName = 'bg-gray-900' }) => {
  return (
    <div className={clsx('rounded-md p-3', bgClassName)}>
      <p className='text-xl text-center text-gray-200'>{label}</p>
    </div>
  );
};

export default ConnectWalletMessage;
